import React, { useContext, useState, useEffect } from "react";
import "../../Organiser/Events/Events.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faEllipsis,
  faSterlingSign,
  faTicket,
  faCoins,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import eventPic from "../../../../assets/concert.png";
import jobPic from "../../../../assets/job.png";
import religiousPic from '../../../../assets/religious.png'
import charityPic from '../../../../assets/charity.png'
import sportsPic from '../../../../assets/sports.png'
import EventContext from "../../Organiser/Events/EventContext";
import axios from "axios";
import UserContext from "../../../../UserContext";
import { toast, ToastContainer } from "react-toastify";
import LoadingScreen from "../../../../LoadingScreen";

const ManageEvents = () => {
  const [activeOption, setActiveOption] = useState("active");
  const [events,setEvents] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
  const [setting, setSetting] = useState({ flag: false, id: null });
  const [currEvent,setCurrEvent] = useState(null);


  // const handleDeleteProcess = async () => {
  //   const confirmation = window.confirm("Are you sure you want to delete this event?");
  
  //   if (confirmation) {
  //     try {
  //       const resp = await axios.delete(
  //         `https://event-finder12.onrender.com/events/deleteevent/${setting.id}`
  //       );
  //       console.log(resp);
  //       toast.success('Successfully Deleted the event')
  //       const filteredEvents = events.filter((event) => event._id !== setting.id);
  //       setEvents(filteredEvents);
  //       setSetting({ flag: false, id: null });
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  // }

  const handleSettingSelected = async (option) => {
    if (option === "delete") {
      const confirmed = window.confirm("Are you sure you want to delete?");
      if (confirmed) {
        deleteEvent();
      }
    }
  };

  const deleteEvent = async () => {
    const body = {
      isAdmin:true
    }
    try{
      await axios.delete(`https://event-finder12.onrender.com/events/deleteevent/${currEvent._id}`,body)
      toast.success("Successfully Deleted the event");
    } catch(err) {
      toast.error(err.message);
    }
  }




  const handleOptions = (e) => {
    setActiveOption(e.target.id);
    console.log(e.target.id);
  };


  const getAllEvents = async () => {
    try {
      const resp = await axios.get(
        `https://event-finder12.onrender.com/admin/manageEvents`
      );
      setEvents(resp.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  // const handleSettingOptions = (eventId) => {
  //   if (setting.flag && setting.id === eventId) {
  //     setSetting({ flag: false, id: null });
  //   } else {
  //     setSetting({ flag: true, id: eventId });
  //     // getEventDetails(eventId)
  //   }
  //   console.log("Setting -", eventId);
  // };

  const getTheEvent = (eventId) => {
    try {
      const selectedUser = events.activeEvents.find((event) => event._id === eventId);
      setCurrEvent(selectedUser);
    } catch (err) {
      console.log(err);
    }
  };

  const getTheExpiredEvent = (eventId) => {
    try {
      const selectedUser = events.expiredEvents.find((event) => event._id === eventId);
      setCurrEvent(selectedUser);
    } catch (err) {
      console.log(err);
    }
  };



  const handleSettingOptions = (eventId) => {
    if (setting.flag && setting.id === eventId) {
      setSetting({ flag: false, id: null });
    } else {
      setSetting({ flag: true, id: eventId });
      if(activeOption==='active')
        getTheEvent(eventId)
      else 
        getTheExpiredEvent(eventId)
    }
  };

  useEffect(() => {
    getAllEvents();

  }, [events]); 


  return (
    <>
    <ToastContainer/>
        <>
          {isLoading ? (
           <LoadingScreen/>
          ) : (
            <>
              <div className="event-outer-container">
                <div className="event-settings-container">
                  <div className="event-header">
                    <div className="event-header-title">
                      <h3>Manage Events</h3>
                    </div>
                    {/* <div onClick={handleCreate} className="event-create-container">
                      + Create
                    </div> */}
                  </div>
                  <div className="event-options">
                    <div
                      onClick={handleOptions}
                      id="active"
                      className={`event-option ${activeOption === "active" ? "active-option" : ""}`}
                    >
                      <h4 id="active" className="event-option-title">
                        Active Events
                      </h4>
                      <h5 id="active" className="event-option-length">
                        {events?.activeEvents?.length}
                      </h5>
                    </div>
                    <div
                      onClick={handleOptions}
                      id="expired"
                      className={`event-option ${activeOption === "expired" ? "active-option" : ""}`}
                    >
                      <h4 id="expired" className="event-option-title">
                        Expired Events
                      </h4>
                      <h5 id="expired" className="event-option-length">
                      {events?.expiredEvents?.length}
                      </h5>
                    </div>
                  </div>
                  <div className="event-list-container">
                    {activeOption==='active' && events?.activeEvents?.length > 0 ? (
                      events?.activeEvents?.map((event) => (
                        
                        <div className="event-info-container" key={event._id}>
                          <div className="event-info-first">
                            <div className="event-info-left">
                              <img
                                className="event-info-icon"
                                src={event.tag==='Music'? eventPic : event.tag==='Charity Event' ? charityPic : event.tag==='Job Event' ? jobPic : event.tag==='Sports' ? sportsPic : event.tag==='Religious Event' ? religiousPic : null}
                                alt="Event Icon"
                              />
                              <div className="event-info-heading">
                                <h3 className="event-info-title">
                                  {event.title}
                                </h3>
                                <h4 className="event-info-subtitle">
                                {event.description.length > 83 ?  event.description.slice(0,83)+"..." : event.description}
                                </h4>
                              </div>
                            </div>
                            <div className="event-info-right">
                              <div className="event-info-date">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <h4>{event.date.split("T")[0]}</h4>
                              </div>
                              <div
                            onClick={() => handleSettingOptions(event._id)}
                            className="event-info-settings"
                          >
                            <FontAwesomeIcon icon={faEllipsis} />
                          </div>
                          {setting.flag && setting.id === event._id && (
                            <ul
                              className={
                                !event.disabled
                                  ? "setting-user-options"
                                  : "setting-user-options disable-background"
                              }
                            >
                              <li
                                id="delete"
                                onClick={() => handleSettingSelected("delete")}
                              >
                                Delete Event
                              </li>
                              {/* {!event.disabled ? (
                                <li
                                  id="disable"
                                  onClick={() =>
                                    handleSettingSelected("disable")
                                  }
                                >
                                  Disable Event
                                </li>
                              ) : (
                                <li
                                  id="enable"
                                  onClick={() =>
                                    handleSettingSelected("enable")
                                  }
                                >
                                  Enable Event
                                </li>
                              )} */}
                            </ul>
                          )}
                            </div>
                          </div>
                          <div className="event-info-second">
                            <div className="event-info-left">
                              <div className="event-info-tag">
                                <h3>{event.tag}</h3>
                              </div>
                              <div className="event-info-location">
                              <div className="event-info-tag sys-admin-tag">
                              <h3 style={{fontSize:"0.9rem"}}><span className="sys-admin-tag" style={{fontWeight:100}}>Owner:</span> {event.createdBy.displayName}</h3>
                              </div>
                                
                              </div>
                              <div className="event-info-location sys-admin-location">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <h3>{event.location.city}</h3>
                              </div>
                            
                            </div>

                            <div className="event-info-right">
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faSterlingSign} />
                                  <h3>Price</h3>
                                </div>
                                <h3>
                                  {event.ticketPrice === 0
                                    ? "Free"
                                    : event.ticketPrice}
                                </h3>
                              </div>
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faTicket} />
                                  <h3>Sold</h3>
                                </div>
                                <h3>{event.ticketSold}</h3>
                              </div>

                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faCoins} />
                                  <h3>Income</h3>
                                </div>
                                <h3>£ {event.income}</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) )
                    ) : activeOption === 'expired' && events?.expiredEvents?.length > 0 ? (
                      events?.expiredEvents?.map((event) => (
                        <div className="event-info-container" key={event._id}>
                          <div className="event-info-first">
                            <div className="event-info-left">
                              <img
                                className="event-info-icon"
                                src={eventPic}
                                alt="Event Icon"
                              />
                              <div className="event-info-heading">
                                <h3 className="event-info-title">
                                  {event.title}
                                </h3>
                                <h4 className="event-info-subtitle">
                                {event.description.length > 83 ?  event.description.slice(0,83)+"..." : event.description}
                                </h4>
                              </div>
                            </div>
                            <div className="event-info-right">
                              <div className="event-info-date">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <h4 style={{color:"red"}}>{event.date.split("T")[0]}</h4>
                              </div>
                              <div
                            onClick={() => handleSettingOptions(event._id)}
                            className="event-info-settings"
                          >
                            <FontAwesomeIcon icon={faEllipsis} />
                          </div>
                          {setting.flag && setting.id === event._id && (
                            <ul
                              className={
                                !event.disabled
                                  ? "setting-user-options"
                                  : "setting-user-options disable-background"
                              }
                            >
                              <li
                                id="delete"
                                onClick={() => handleSettingSelected("delete")}
                              >
                                Delete Event
                              </li>
                              {/* {!event.disabled ? (
                                <li
                                  id="disable"
                                  onClick={() =>
                                    handleSettingSelected("disable")
                                  }
                                >
                                  Disable Event
                                </li>
                              ) : (
                                <li
                                  id="enable"
                                  onClick={() =>
                                    handleSettingSelected("enable")
                                  }
                                >
                                  Enable Event
                                </li>
                              )} */}
                            </ul>
                          )}
                            </div>
                          </div>
                          <div className="event-info-second">
                            <div className="event-info-left">
                              <div className="event-info-tag">
                                <h3>{event.tag}</h3>
                              </div>
                              <div className="event-info-location ">
                              <div className="event-info-tag sys-admin-tag">
                              <h3 style={{fontSize:"0.9rem"}}><span className="sys-admin-tag" style={{fontWeight:100}}>Owner:</span> {event.createdBy.displayName}</h3>
                              </div>
                                
                              </div>
                              <div className="event-info-location sys-admin-location">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <h3>{event.location.city}</h3>
                              </div>
                            </div>

                            <div className="event-info-right">
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faSterlingSign} />
                                  <h3>Price</h3>
                                </div>
                                <h3>
                                  {event.ticketPrice === 0
                                    ? "Free"
                                    : event.ticketPrice}
                                </h3>
                              </div>
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faTicket} />
                                  <h3>Sold</h3>
                                </div>
                                <h3>{event.ticketSold}</h3>
                              </div>

                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faCoins} />
                                  <h3>Income</h3>
                                </div>
                                <h3>£ {event.income}</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <h1 className="no-event">No Events</h1>
                    ) }
                  </div>
                </div>
              </div>
            </>
          )}
        </>
    </>
  );
};

export default ManageEvents;
